import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
    ApplicantsList,
    ApplyJobRequest,
CreateJob,CreateJobResponse,DeleteJobResponse,EditJobRequest,EditJobResponse,EditJobValidityResponse,JobsResponse,
    JobsResponseById,
    JobsResponseForCompany,
    JobsResponseForSearch,
    LogosResponse,
    UpdateJobstatus,
UpdateJobstatusResponse
} from '../model/jobs.model';

@Injectable({
    providedIn: 'root'
})
export class JobsService {
    private apiEndPoint = environment.APIEndpoint;
     private jobData: any;

    setJob(data: any) {
        this.jobData = data;
    }

    getJob() {
        return this.jobData;
    }

    constructor(
        private http: HttpClient,
    ) { }

    //API endpoint to create a new job by the mentor 
    createJob(data:CreateJob){
        const path = this.apiEndPoint + '/jobs/create-job';
        return this.http.post<any>(path,data);
    }

    //API endpoint to get count list of all the jobs created by the logged in mentor
    getJobsCreatedByMentor(currentPage: any = 1):Observable<JobsResponse>{
        let params = new HttpParams();
        params = params.append('page', currentPage);
        return this.http.get<JobsResponse>(this.apiEndPoint + '/jobs/user-jobs', { params });
    }

    //API endpoint to get the details of the job post given its job _id
    getJobById(job_id: string):Observable<JobsResponseById>{
        let path = '/jobs/job-details?job_id='+job_id;
        return this.http.get<JobsResponseById>(this.apiEndPoint+path);
    }

    //API endpoint to soft delete the job post
    deleteJob(job_id: string): Observable<DeleteJobResponse> {
        const path = `/jobs/delete-job?job_id=${encodeURIComponent(job_id)}`;
        return this.http.delete<DeleteJobResponse>(this.apiEndPoint + path);
    }
    
    //API endpoint to close the job post once our canidature has been completed
    updateJobStatus(job_id: string, status: string): Observable<UpdateJobstatusResponse> {
        const path = `/jobs/edit-job-status`;
        const body = {
            job_id: job_id,
            status: status
        };
        return this.http.patch<UpdateJobstatusResponse>(this.apiEndPoint + path, body);
    }

    //API endpoint to serach the jobs by the student based on the keyword
    searchByKeyword(keyword: string):Observable<JobsResponseForSearch>{
        let path ='/jobs/search-by-keywords?keyword='+keyword;
        return this.http.get<JobsResponseForSearch>(this.apiEndPoint+path)
    }

    //API endpoint to get list of all the jobs which are active
    allJobs():Observable<JobsResponse>{
        let path ='/jobs/all-jobs';
        return this.http.get<JobsResponse>(this.apiEndPoint+path)
    }

    //API enpoint to get the count and list of jobs based on role 
    searchByRole(role: string):Observable<JobsResponseForSearch>{
        let path ='/jobs/jobs-list-for-role?role='+role;
        return this.http.get<JobsResponseForSearch>(this.apiEndPoint+path)
    }

    //API enpoint to get the count and list of jobs based on skills
    searchBySkills(skills: string[]):Observable<JobsResponseForSearch>{
        let path ='/jobs/jobs-list-for-skills?skill='+skills;
        return this.http.get<JobsResponseForSearch>(this.apiEndPoint+path)
    }

    //API enpoint to get the count and list of jobs based on location
    searchByLocation(locations:string[]):Observable<JobsResponseForSearch>{
        let path ='/jobs/jobs-list-for-location?location='+locations;
        return this.http.get<JobsResponseForSearch>(this.apiEndPoint+path)
    }

    //API enpoint to get the count and list of jobs based on workexperience
    searchByWorkExperience(experience: string):Observable<JobsResponseForSearch>{
        let path ='/jobs/jobs-list-by-experience?experience='+experience;
        return this.http.get<JobsResponseForSearch>(this.apiEndPoint+path)
    }

    //API enpoint to get the count and list of jobs based on salary range
    searchBySalaryRange(min_salary:number,max_salary:number):Observable<JobsResponseForSearch>{
        let path ='/jobs/jobs-list-by-salary-range?min_salary='+min_salary+'&max_salary='+max_salary;
        return this.http.get<JobsResponseForSearch>(this.apiEndPoint+path)
    }

    //API enpoint to get the count and list of jobs based on multiple filters such as role, skills, location, experience, salary range, remote work_mode_preference
    searchByMultipleFilters(role:string,skill:string,location:string,
        experience:string,min_salary:string,max_salary:string,remote:boolean
    ):Observable<JobsResponseForSearch>{
        let path ='/jobs/search-combined?role='+role+'&skill='+skill+'&location='+location+'&experience='+experience+'&min_salary='+min_salary+'&max_salary='+max_salary+'&remote='+remote;
        return this.http.get<JobsResponseForSearch>(this.apiEndPoint+path)
    }

    //API enpoint to get list of all the company logos along with company name
    allCompanyLogos():Observable<LogosResponse>{
        let path ='/jobs/company-logos';
        return this.http.get<LogosResponse>(this.apiEndPoint+path)
    }

    //API enpoint to apply for the selected job 
    applyForJob(postData: any): Observable<any> {
        const path = this.apiEndPoint + '/jobs/apply-job';
        const formData = new FormData();
        formData.append('job_id', postData.job_id);
        formData.append('resume', postData.resumeFile);
        formData.append('cv', postData.cvFile);

        return this.http.post<any>(path, formData);
    }

    //API endpoint to get list of applicants for the specific job id 
    applicantsListForJobId(job_id: string, page: number = 1):Observable<ApplicantsList>{
        let path = '/jobs/applicants-list?job_id='+job_id+'&page='+page;
        return this.http.get<ApplicantsList>(this.apiEndPoint+path);
  
    }

    searchByCompany(company: string):Observable<JobsResponseForCompany>{
        let path = '/jobs/jobs-list-for-company?company='+company;
        return this.http.get<JobsResponseForCompany>(this.apiEndPoint+path)
    }

    editJobDetails(data):Observable<any>{
        const path = this.apiEndPoint + '/jobs/edit-job-details';
        return this.http.patch<any>(path,data);
    }
    
    editJobValidity(data: EditJobRequest): Observable<EditJobValidityResponse> {
        const path = `/jobs/edit-job-validity`;
        const body = {
            job_id: data.job_id,
            job_title: data.job_title,
            company: data.company,
            tags: data.tags,
            location: data.location,
            job_description: data.job_description,
            work_mode_preference: data.work_mode_preference,
            salary: data.salary,
            validity: data.validity,
            experience: data.experience
        };
        return this.http.patch<EditJobValidityResponse>(this.apiEndPoint + path, body);
    }

    // API endpoint to get the job filter criteria
    searchFilter(data: any): Observable<any> {
        const path = this.apiEndPoint + '/jobs/get-job-filter';
        return this.http.post<any>(path,data);
    }

    // API endpoint to get all jobs based on the filter criteria
    getJobs(currentPage: any = 1): Observable<any> {
        const path = this.apiEndPoint + '/jobs/all-jobs';
        let params = new HttpParams();
        params = params.append('page', currentPage);
        return this.http.get<any>(path,  { params });
    }

    //API endpoint to update applicant status
    updateApplicantStatus(job_id: string, applicant_id: string, status: string): Observable<any> {
        const path = `/jobs/edit-applicant-status`;
        const body = {
            job_id: job_id,
            applicant_id: applicant_id,
            status: status
        };
        return this.http.patch<any>(this.apiEndPoint + path, body);
    }

    /**
     * To get searched jobs
     * @param currentPage - To get page number
     * @returns - api data on success or error
     */
    searchJobs(query = '', currentPage: any = 1): Observable<any>{
        const path = this.apiEndPoint + '/jobs/search';
        let params = new HttpParams();
        params = params.append('query', query);
        params = params.append('page', currentPage);
        return this.http.get<any>(path,  { params });
    }

    /**
     * To get job applications
     * @param currentPage - To get page number
     * @returns - api data on success or error
     */
    getJobApplications(currentPage: any = 1): Observable<any> {
        const path = this.apiEndPoint + '/jobs/my-applications';
        let params = new HttpParams();
        params = params.append('page', currentPage);
        return this.http.get<any>(path,  { params });
    }
}